import { useState } from 'react';
import UnitSwitch from '../../../components/unitSwitch/UnitSwitch';
import { s, p } from './AppraisalPrice.styles';
import { t } from '../../../detail/components/Table.styles';
import { TotalSaleList } from '../../data';
import { ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';
import styled from 'styled-components';
import ReferenceLink from '../../ReferenceLink';
import { data } from 'react-router-dom';
const attachmentIcon = '/assets/images/icon/Icon_Attachment.svg';
interface ListItemProps {
  sno: string;
  saddr: string;
  type: string | null;
  areaPyeong: string;
  areaMeter: number;
  status: string | null;
  appraisePricePerMeter: number;
  officialpricePerMeter: number | null;
  appraisePrice: number | null;
  etc: string;
  sinfo?: string;
  data: any; 
}

interface Props {
  totalSaleList: TotalSaleList;
  landSaleList: [
    { totalAreaPyeong: number; totalAreaMeter: number; appraisalPrice: number },
    {
      list: ListItemProps[];
      isLandRight: boolean;
    },
  ];
  buildingSaleList: [
    { totalArea: number; totalAreaMeter: number; appraisalPrice: number },
    {
      list: ListItemProps[];
      isLandRight: boolean;
    },
  ];
  appraisalInfo:
    | {
        appraise_date: string;
        appraiser: string;
        lessee_date: string;
      }
    | undefined;
  saleItemInfo: string[];
  a_table: any;
   data?: any;
  linkSet?: { 
    buttonLink?: { 
      appraisal?: string; 
    }; 
  };
}

type AuctionAppraisalPriceProps = {
  totalSaleList: any;
  landSaleList: any;
  buildingSaleList: any;
  appraisalInfo: any;
  saleItemInfo: any;
  a_table: any;
  data: any;
  linkSet: any;
};

const AuctionAppraisalPrice = ({
  totalSaleList,
  landSaleList,
  buildingSaleList,
  appraisalInfo,
  saleItemInfo,
  a_table,
  data,
  linkSet,
}: AuctionAppraisalPriceProps) => {
  const [unit, setUnit] = useState('평');
  const { itemType } = useReportContext();

  const aTable = JSON.parse(a_table);
  const isHeaderText = (text: string) => /^\d+\)/.test(text);

  const renderAppraisalContent = (aTable: any[]) => {
    if (!aTable) return null;
    

    return aTable.slice(1).map((item: any, index: number, array: any[]) => {
      try {
        if (typeof item !== 'string') {
          throw new Error(
            `Invalid item type at index ${index}: ${typeof item}`,
          );
        }

        const meaninglessPattern = /^[-.\s]*$/;
        const isHeader = isHeaderText(item);

        // Skip rendering meaningless content or headers followed by meaningless content
        if (
          meaninglessPattern.test(item) ||
          (isHeader &&
            array[index + 1] &&
            meaninglessPattern.test(array[index + 1]))
        ) {
          return null;
        }

        // Clean and format the content
        let formattedText = item
          .replace(/(<br\s*\/?>(\s*)?){2,}/g, '<br/>')
          .replace(/(<[^<>]*?)<br\s*\/?>([^<>]*?>)/g, '$1$2')
          .replace(/<br\s*\/?>(\s*)?/g, '\n');

        return (
          <s.ATableContent isHeader={isHeader} key={index}>
            {formattedText}
          </s.ATableContent>
        );
      } catch (error) {
        console.error(`Error processing item at index ${index}:`, error);
        return (
          <s.ATableContent isHeader={isHeaderText(item)} key={index}>
            {item}
          </s.ATableContent>
        );
      }
    });
  };

  return (
    <Container id="감정가">
      {/* 감정가 써머리 */}
      <s.Block style={{gap:'24px'}}>
        <TitleBox>
          감정가
        {linkSet?.buttonLink?.appraisal && (  
        <AttachButton onClick={() => {
        if (linkSet?.buttonLink?.appraisal) {
          window.open(linkSet.buttonLink.appraisal, '_blank');
        }
        }}>
          <AttachBox>
            <img src={attachmentIcon} alt="첨부파일" width={16} />
           감정평가서
          </AttachBox>
        </AttachButton>
        )}
      </TitleBox>
        <s.Summary>
          <s.SummaryRow>
            <s.SummaryLabel>감정원</s.SummaryLabel>
            <span>{ReportFormatNumber(totalSaleList.buildingPrice)}</span>
          </s.SummaryRow>
           {Number(totalSaleList.buildingPrice) > 0 && (
          <>
          <s.SummaryRow>
            <s.SummaryLabel>가격시점</s.SummaryLabel>
            <span>
              {appraisalInfo?.appraise_date?.includes(':')
                ? appraisalInfo.appraise_date
                    .split('/')[0]
                    ?.split(':')[1]
                    ?.trim()
                : ''}
            </span>
          </s.SummaryRow>
          <s.SummaryRow>
            <s.SummaryLabel>보존등기일</s.SummaryLabel>
            <span>
              {appraisalInfo?.appraise_date?.includes('/')
                ? appraisalInfo.appraise_date
                    .split('/')[1]
                    ?.split(':')[1]
                    ?.trim()
                : '-'}
            </span>
              </s.SummaryRow>
            </>
             )}
        </s.Summary>
        {a_table && (
          <s.AppraisalPriceSummary>
            <s.ATableTitle>
              <img src="/assets/images/icon/checklist.svg" alt="" />
              <span>감정평가서 요약</span>
            </s.ATableTitle>
            {renderAppraisalContent(aTable)}
          </s.AppraisalPriceSummary>
        )}
      </s.Block>
      {/* 전체감정가 */}
      <s.Block>
        <s.BlockTitleBox>
          <s.BlockTitle>
            <img src="/assets/images/icon/money.svg" alt="" />
            <span>전체 감정가</span>
          </s.BlockTitle>
          <UnitSwitch unit={unit} setUnit={setUnit} icon />
        </s.BlockTitleBox>
        <t.Table>
          <thead>
            <t.Row>
              <t.TableHeadTh width="72px">전체목록</t.TableHeadTh>
              <t.TableHeadTh width="110px">면적</t.TableHeadTh>
              <t.TableHeadTh width="144px">감정가</t.TableHeadTh>
            </t.Row>
          </thead>
          <tbody>
            <t.Row>
              <t.ContentCell width="72px" border={true} textAlign="center">
                토지{' '}
              </t.ContentCell>
              <t.ContentCell width="110px" border={true} textAlign="center">
                {unit === '평'
                  ? `${totalSaleList.landAreaPyeong.toFixed(1)}평`
                  : `${totalSaleList.landAreaMeter.toFixed(1)}m²`}
              </t.ContentCell>
              <t.ContentCell width="144px" border={true} textAlign="center">
                {ReportFormatNumber(totalSaleList.landPrice)}
              </t.ContentCell>
            </t.Row>
            <t.Row>
              <t.ContentCell width="72px" border={true} textAlign="center">
                건물{' '}
              </t.ContentCell>
              <t.ContentCell width="110px" border={true} textAlign="center">
                {unit === '평'
                  ? `${totalSaleList.buildingAreaPyeong.toFixed(1)}평`
                  : `${totalSaleList.buildingAreaMeter.toFixed(1)}m²`}
              </t.ContentCell>
              <t.ContentCell width="144px" border={true} textAlign="center">
                {ReportFormatNumber(totalSaleList.landPrice)}
              </t.ContentCell>
            </t.Row>
            <t.Row>
              <t.TitleCell width="auto" colSpan={3}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <span style={{ color: '#222' }}>감정가합계</span>
                  <span style={{ fontWeight: 700, color: '#008AFF' }}>
                    {ReportFormatNumber(
                      totalSaleList.landPrice + totalSaleList.buildingPrice,
                    )}
                  </span>
                </div>
              </t.TitleCell>
            </t.Row>
          </tbody>
        </t.Table>
      </s.Block>
      {/* 토지감정가 */}
      <s.Block>
        <s.BlockTitleBox>
          <s.BlockTitle>
            <img src="/assets/images/icon/forest.svg" alt="" />
            <span>토지 감정가</span>
          </s.BlockTitle>
        </s.BlockTitleBox>
        <t.Table>
          <thead>
            <t.Row>
              <t.TableHeadTh width="auto">면적소계</t.TableHeadTh>
              <t.TableHeadTh width="auto">감정가소계</t.TableHeadTh>
            </t.Row>
          </thead>
          <tbody>
            <t.Row>
              <t.ContentCell width="auto" border={true} textAlign="center">
                {landSaleList[0].totalAreaMeter.toFixed(1)}m² (
                {landSaleList[0].totalAreaPyeong.toFixed(1)}평)
              </t.ContentCell>
              <t.ContentCell width="auto" border={true} textAlign="center">
                {ReportFormatNumber(landSaleList[0].appraisalPrice)}
              </t.ContentCell>
            </t.Row>
          </tbody>
        </t.Table>
        {landSaleList[1].isLandRight ? (
          <>
            {landSaleList[1].list.map((item: any, index: any) => (
              <t.Table>
                <tbody>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      구분
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {index + 1}
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      면적
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {Number(item.areaMeter).toFixed(1)}m²(
                      {Number(item.areaPyeong).toFixed(1)}평)
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      m²당 단가 <br />
                      (공시지가)
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {ReportFormatNumber(item.appraisePricePerMeter)}
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      감정가
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {ReportFormatNumber(Number(item.appraisePrice))}
                    </t.ContentCell>
                  </t.Row>
                </tbody>
              </t.Table>
            ))}
          </>
        ) : (
          <>
            {landSaleList[1].list.map((item: any, index: any) => (
              <t.Table>
                <tbody>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      구분
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {index + 1}
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      지번
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {item.saddr}
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      용도/구조/면적/
                      <br /> 토지이용계획
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {item.status === null ? '-' : item.status} <br />
                      {Number(item.areaMeter).toFixed(1)}m²(
                      {Number(item.areaPyeong).toFixed(1)}평)
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      m²당 단가 <br />
                      (공시지가)
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {ReportFormatNumber(item.appraisePricePerMeter)}
                    </t.ContentCell>
                  </t.Row>
                  <t.Row>
                    <t.TitleCell width="110px" border={true} textAlign="center">
                      감정가
                    </t.TitleCell>
                    <t.ContentCell width="auto" border={true} textAlign="left">
                      {ReportFormatNumber(Number(item.appraisePrice))}
                    </t.ContentCell>
                  </t.Row>
                </tbody>
              </t.Table>
            ))}
          </>
        )}
      </s.Block>
      {/* 건물 감정가 */}
      {itemType === 'H' && (
        <s.Block>
          <s.BlockTitleBox>
            <s.BlockTitle>
              <img src="/assets/images/icon/building.svg" alt="" />
              <span>건물 감정가</span>
            </s.BlockTitle>
          </s.BlockTitleBox>
          <t.Table>
            <thead>
              <t.Row>
                <t.TableHeadTh width="auto">면적소계</t.TableHeadTh>
                <t.TableHeadTh width="auto">감정가소계</t.TableHeadTh>
              </t.Row>
            </thead>
            <tbody>
              <t.Row>
                <t.ContentCell width="auto" border={true} textAlign="center">
                  {buildingSaleList[0].totalAreaMeter.toFixed(1)}m² (
                  {buildingSaleList[0].totalArea.toFixed(1)}평)
                </t.ContentCell>
                <t.ContentCell width="auto" border={true} textAlign="center">
                  {ReportFormatNumber(buildingSaleList[0].appraisalPrice)}
                </t.ContentCell>
              </t.Row>
            </tbody>
          </t.Table>
          {buildingSaleList[1].isLandRight ? (
            <>
              {buildingSaleList[1].list.map((item: any, index: any) => (
                <t.Table>
                  <tbody>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        구분
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {index + 1}
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        지번
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {item.saddr}
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        면적
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {Number(item.areaMeter).toFixed(1)}m²(
                        {Number(item.areaPyeong).toFixed(1)}평)
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        감정가
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {ReportFormatNumber(Number(item.appraisePrice))}
                      </t.ContentCell>
                    </t.Row>
                  </tbody>
                </t.Table>
              ))}
            </>
          ) : (
            <>
              {buildingSaleList[1].list.map((item: any, index: any) => (
                <t.Table>
                  <tbody>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        구분
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {index + 1}
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        지번
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {item.saddr}
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                        rowSpan={2}
                      >
                        용도/구조/면적/
                        <br /> 토지이용계획
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {`${item.sinfo ?? '-'} / ${item.status ?? '-'} `}
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {Number(item.areaMeter).toFixed(1)}m²(
                        {Number(item.areaPyeong).toFixed(1)}평)
                      </t.ContentCell>
                    </t.Row>
                    <t.Row>
                      <t.TitleCell
                        width="110px"
                        border={true}
                        textAlign="center"
                      >
                        감정가
                      </t.TitleCell>
                      <t.ContentCell
                        width="auto"
                        border={true}
                        textAlign="left"
                      >
                        {ReportFormatNumber(Number(item.appraisePrice))}
                      </t.ContentCell>
                    </t.Row>
                  </tbody>
                </t.Table>
              ))}
            </>
          )}
        </s.Block>
      )}
      <t.GrayBox>
        <t.NoteTitle>이용현황</t.NoteTitle>
        <div>{saleItemInfo}</div>
      </t.GrayBox>
    </Container>
  );
};

export default AuctionAppraisalPrice;
export const PAuctionAppraisalPrice = ({ data, link, linkSet }: any) => {
  const pAuctionInfoArray = JSON.parse(data);
  const flattenedArray = pAuctionInfoArray.flat();
  return (
    <p.PContainer id="감정가">
       <TitleBox style={{ fontSize: '18px', fontWeight: '700'}}>
        감정가
        {linkSet?.buttonLink?.appraisal && (
          <AttachButton onClick={() => {
            if (linkSet?.buttonLink?.appraisal) {
              window.open(linkSet.buttonLink.appraisal, '_blank');
            }
          }}>
            <AttachBox>
              <img src={attachmentIcon} alt="첨부파일" width={16} />
              감정평가서
            </AttachBox>
          </AttachButton>
            )}
      </TitleBox>
      <s.Summary>
        <s.SummaryRow>
          <p.PSummaryLabel>감정평가기관</p.PSummaryLabel>
          <span>{flattenedArray[0]}</span>
        </s.SummaryRow>
        <s.SummaryRow>
          <p.PSummaryLabel>평가일</p.PSummaryLabel>
          <span>{flattenedArray[1]}</span>
        </s.SummaryRow>
        <s.SummaryRow>
          <p.PSummaryLabel>평가금액</p.PSummaryLabel>
          <span>{flattenedArray[2]}</span>
        </s.SummaryRow>
        {/* <s.SummaryRow>
          <p.PSummaryLabel>평가감정서</p.PSummaryLabel>
            <a
            href={link}
            onClick={(e) => {
              if (!link) return;

              e.preventDefault(); // 기본 이동 방지
              window.open(link, '_self'); // 새로운 창에서 다운로드 실행
            }}
          >
            감정평가서
          </a>
        </s.SummaryRow> */}
      </s.Summary>
    </p.PContainer>
  );
};

const TableWrapper = styled.div`
  border: 1px solid #e1e2e4;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  background-color: #fff;
  gap: 24px;

  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const AttachButton = styled.div`
  
`

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AttachBox = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
`;